// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"df51b95a","60":"8a8a466b","168":"92489f83","453":"5d53c2c2","746":"0ad4faa2","929":"cc8b1aa7","992":"c5c1e798"}[chunkId] + ".chunk.js";
};